/**
 *  Filters mutations module file
**/

import { MUTATIONS } from './constants'
import { defaultFilters } from './state'

export const mutations = {
  [MUTATIONS.SET_FILTER_VALUE] (state, { key, value }) {
    state.filters = state.filters.map(f => {
      if (f.key === key) {
        f.value = value
      }
      return f
    })
  },
  [MUTATIONS.TOGGLE_FILTER] (state, { key, value }) {
    state.filters = state.filters.map(f => {
      if (f.key === key) {
        f.enabled = value
      }
      return f
    })
  },
  [MUTATIONS.CLEAR_ALL_FILTERS] (state) {
    state.filters = defaultFilters()
  }
}
